import { PaymentMethod } from 'ha/services/apiV2/types/PaymentMethod';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Payload {
  paymentProvider: string;
  authToken: string;
  billingCountryCode: string;
}
export default (makeCall: MakeCall) =>
  (
    userId: number,
    { paymentProvider, authToken, billingCountryCode }: Payload,
  ) =>
    makeCall<PaymentMethod>('POST', `/api/v2/user/${userId}/payment-method`, {
      data: {
        paymentProvider,
        authToken,
        billingCountryCode,
      },
    });
